import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const updateDraftAmends = api(async function updateDraftAmends({
    auditId,
    projectId,
    type,
    referenceId,
    shortDescription,
    longDescription,
    payload,
}) {
    return mutate(
        gql`
            mutation updateDraftAmends(
                $auditId: String
                $projectId: String!
                $type: String!
                $referenceId: String!
                $shortDescription: String
                $longDescription: String
                $payload: JSONObject
            ) {
                updateDraftAmends(
                    auditId: $auditId
                    projectId: $projectId
                    type: $type
                    referenceId: $referenceId
                    shortDescription: $shortDescription
                    longDescription: $longDescription
                    payload: $payload
                )
            }
        `,
        { auditId, projectId, type, referenceId, shortDescription, longDescription, payload },
        { returns: "updateDraftAmends" }
    )
})
